<template>
  <b-modal class="modal-lg" id="deleteModal" ref="delete-modal" :title="deleteModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary"  @show="fetchAdditionalInfo()" @hide="resetModal('main')">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'trash-alt']" size="1x" class="mr-2"/> {{ deleteModal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <template v-if="deleteModal.docuData.docsChecked && deleteModal.docuData.docsChecked.length">
        <h5 class="py-2 text-center">{{ t('docDeleteModalHeading','docDeleteModalHeading') }}</h5>
        <p class="text-center">{{ t('docDeleteModalDesc','docDeleteModalDesc') }}</p>
        <ul class="list-unstyled" >
          <li v-for="docInfo in docsInfo" :key="docInfo.reference">
            <fontAwesomeIcon :icon="['fas', 'file']" size="1x"/> {{ docInfo.reference }}
          </li>
        </ul>
      </template>
      <template v-else>
        <h5 class="text-danger text-center"><fontAwesomeIcon :icon="['fas', 'exclamation-triangle']" size="1x" class="mr-2"/> {{t('noDocsSelected','noDocsSelected')}}</h5>
        <p class="text-danger text-center">{{t('pleaseSelectDocsFirst','pleaseSelectDocsFirst')}}</p>
      </template>
      <ResponseInfo v-if="getResponseInfo.responseName == 'documentsView'"></ResponseInfo>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
        <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
      </button>
      <template v-if="deleteModal.docuData.docsChecked.length">
        <div v-if="buttonIsBusy">
          <div class="sk-folding-cube">
            <div class="sk-cube1 sk-cube"></div>
            <div class="sk-cube2 sk-cube"></div>
            <div class="sk-cube4 sk-cube"></div>
            <div class="sk-cube3 sk-cube"></div>
          </div>
        </div>
        <button v-if="!buttonIsBusy" aria-label="Payment" data-dismiss="modal" class="btn btn-primary" type="button" @click="deleteDocs()">
          <fontAwesomeIcon :icon="['fa', 'trash-alt']" size="1x" /> {{ t('deleteButtonText', 'deleteButtonText')}}
        </button>
      </template>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'ModalDeleteDoc',
  //this component inherits from the Search.vue component
  inject: [
    'resetModal',
    'searchDocuments'
  ],
  data () {
    return {
      deleteModal: {},
      buttonIsBusy: false
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),
    docsToDelete() {
      return this.deleteModal.docuData.docsChecked
    },
    docsInfo() {
      return this.deleteModal.docuData.statuses
    }
  },
  methods:{
    fetchAdditionalInfo() {
      this.buttonIsBusy = false
      this.$store.dispatch('alertClearResponse')
    },
    deleteDocs() {
      this.buttonIsBusy = true
      this.$store.dispatch('documentToolsStore/handleDocumentTool', {
        action: 'deleteDocuments',
        documents: this.deleteModal.docuData.docsChecked
      }).then(() => {
        let responseStatus = this.getResponseInfo.status
        if(responseStatus != 'error') {
          this.buttonIsBusy = false
          this.$parent.documentsData.docsChecked = [] // EIPP-199 clear checked docs after delete, PW
          this.$parent.documentsData.statuses = []
          this.deleteModal.docuData.docsChecked = []
          this.deleteModal.docuData.statuses = []
          this.searchDocuments()
          this.$refs['delete-modal'].hide()
        }
      })
    }
  },
  created() {
    this.deleteModal = this.$attrs.modal
  },
  components:{
    ResponseInfo
  }
}
</script>

<style scoped>
.button-h {
  max-height: 30px;
}
.modal-open #deleteModal___BV_modal_outer_ >>> .modal-content{
  min-width: 850px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #deleteModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 520px;
  overflow-y: scroll;
}
.doc-list {
  width: 300px;
  height: 250px;
  overflow: auto;
}
.nav-link >>> .doc-button{
  border-radius: 0 !important;
}
.list-columns{
  columns: 6
}
</style>
